/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Trip_Load_One_LinerInputs */

const en_exp_trip_load_one_liner = /** @type {(inputs: Exp_Trip_Load_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The combined training stress of every session in this trip — each session's score added together. One hard hour scores about 100.`)
};

const de_exp_trip_load_one_liner = /** @type {(inputs: Exp_Trip_Load_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die gesamte Trainingsbelastung aller Einheiten dieser Tour — die Werte der Einheiten aufsummiert. Eine harte Stunde bringt rund 100.`)
};

/**
* | output |
* | --- |
* | "The combined training stress of every session in this trip — each session's score added together. One hard hour scores about 100." |
*
* @param {Exp_Trip_Load_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_trip_load_one_liner = /** @type {((inputs?: Exp_Trip_Load_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Trip_Load_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_trip_load_one_liner(inputs)
	return de_exp_trip_load_one_liner(inputs)
});